import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("kmu_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const resolveImage = (url) => {
  if (!url) return "";
  if (url.startsWith("/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
};

export default api;
